'use client';

import { c as _c } from "react/compiler-runtime";
import appStoreLogoEn from '@public/images/app_store.svg';
import appStoreLogoFr from '@public/images/app_store_fr.svg';
import googlePlayLogoEn from '@public/images/google_play.svg';
import googlePlayLogoFr from '@public/images/google_play_fr.svg';
import Image from 'next/image';
import Link from 'next/link';
import { LocaleSwitcher } from '@src/components/LocaleSwitcher/LocaleSwitcher';
import type { TopNavV6Props } from '@src/components/TopNavV6/TopNavV6Props';
import { configPublic } from '@src/config.public';
import { useLocale } from '@src/i18n/LocaleProvider';
import { useTrackSelectCta } from '@src/utils/analytics.util';
import facebookImg from '../../BigFooter/assets/facebook.svg';
import instagramImg from '../../BigFooter/assets/instagram.svg';
import youtubeImg from '../../BigFooter/assets/youtube.svg';
export const TopNavV6MobileFooter = props => {
  const $ = _c(44);
  const {
    locale
  } = useLocale();
  const trackSelectCta = useTrackSelectCta();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      en: appStoreLogoEn,
      fr: appStoreLogoFr
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const appStoreLogo = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      en: googlePlayLogoEn,
      fr: googlePlayLogoFr
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const googlePlayLogo = t1;
  const appStoreUrl = configPublic.general.bodIosAppUrl ?? "https://apps.apple.com/us/app/bodi-by-beachbody-home-fitness/id1031660123";
  const googlePlayUrl = configPublic.general.bodAndroidAppUrl ?? "https://play.google.com/store/apps/details?id=com.beachbody.bod";
  const {
    instagramUrl: t2,
    facebookUrl: t3,
    youtubeUrl: t4
  } = props;
  const instagramUrl = t2 === undefined ? "https://instagram.com/bodi" : t2;
  const facebookUrl = t3 === undefined ? "https://facebook.com/bodi" : t3;
  const youtubeUrl = t4 === undefined ? "https://youtube.com/@bodi" : t4;
  const t5 = appStoreLogo[locale.lang];
  let t6;
  if ($[2] !== trackSelectCta) {
    t6 = () => {
      trackSelectCta({
        "cta url": appStoreUrl
      });
    };
    $[2] = trackSelectCta;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== t5 || $[5] !== t6) {
    t7 = <Link href={appStoreUrl} className="shrink-0"><Image className="h-10" src={t5} width={120} height={40} alt="App Store" onClick={t6} /></Link>;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const t8 = googlePlayLogo[locale.lang];
  let t9;
  if ($[7] !== trackSelectCta) {
    t9 = () => {
      trackSelectCta({
        "cta url": googlePlayUrl
      });
    };
    $[7] = trackSelectCta;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== t8 || $[10] !== t9) {
    t10 = <Link href={googlePlayUrl} className="shrink-0"><Image className="h-10" src={t8} width={135} height={40} alt="Google Play" onClick={t9} /></Link>;
    $[9] = t8;
    $[10] = t9;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== t10 || $[13] !== t7) {
    t11 = <div className="mx-auto flex gap-6">{t7}{t10}</div>;
    $[12] = t10;
    $[13] = t7;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== instagramUrl || $[16] !== trackSelectCta) {
    t12 = () => {
      trackSelectCta({
        "cta url": instagramUrl
      });
    };
    $[15] = instagramUrl;
    $[16] = trackSelectCta;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Image src={instagramImg} width={36} height={36} alt="Instagram" className="invert" />;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== instagramUrl || $[20] !== t12) {
    t14 = <Link href={instagramUrl} onClick={t12}>{t13}</Link>;
    $[19] = instagramUrl;
    $[20] = t12;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== facebookUrl || $[23] !== trackSelectCta) {
    t15 = () => {
      trackSelectCta({
        "cta url": facebookUrl
      });
    };
    $[22] = facebookUrl;
    $[23] = trackSelectCta;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Image src={facebookImg} width={36} height={36} alt="Facebook" className="invert" />;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== facebookUrl || $[27] !== t15) {
    t17 = <Link href={facebookUrl} onClick={t15}>{t16}</Link>;
    $[26] = facebookUrl;
    $[27] = t15;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== trackSelectCta || $[30] !== youtubeUrl) {
    t18 = () => {
      trackSelectCta({
        "cta url": youtubeUrl
      });
    };
    $[29] = trackSelectCta;
    $[30] = youtubeUrl;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  let t19;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Image src={youtubeImg} width={36} height={36} alt="YouTube" className="invert" />;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  let t20;
  if ($[33] !== t18 || $[34] !== youtubeUrl) {
    t20 = <Link href={youtubeUrl} onClick={t18}>{t19}</Link>;
    $[33] = t18;
    $[34] = youtubeUrl;
    $[35] = t20;
  } else {
    t20 = $[35];
  }
  let t21;
  if ($[36] !== t14 || $[37] !== t17 || $[38] !== t20) {
    t21 = <div className="mx-auto flex gap-6">{t14}{t17}{t20}</div>;
    $[36] = t14;
    $[37] = t17;
    $[38] = t20;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <div className="mx-auto"><LocaleSwitcher /></div>;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] !== t11 || $[42] !== t21) {
    t23 = <div className="flex flex-col gap-8 px-4 pb-8">{t11}{t21}{t22}</div>;
    $[41] = t11;
    $[42] = t21;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  return t23;
};